import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import ScrollToTop from "./components/ScrollToTop";
import "./App.css";

const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/service/:serviceName" component={ServicePage} />
      </Switch>
      <ScrollToTop />
    </Router>
  );
};

export default App;
